export { default as Modal } from './Modal';
